/**
 * Per-step sponsor share: action labels, share/final action ids, schema metadata.
 */

import { getDefaultShareEmptyMessage, STEP_UI } from './uiStrings';
import { getStepActionLabelsForStep } from './stepActionLabels';
import { getStepPageTitle } from './stepPageCopy';

export interface StepShareMeta {
  stepNumber: number;
  stepTitle: string;
  shareName: string;
  documentType: string;
  shareActionId: number;
  secondaryShareActionIds?: number[];
  finalActionId: number;
  shareButtonText?: string;
  actionLabels: Record<number, string>;
  actionCount: number;
}

interface StepShareMetaBase {
  stepNumber: number;
  /** English share-document record name (API / PDF pipeline — not UI chrome). */
  shareName: string;
  documentType: string;
  shareActionId: number;
  secondaryShareActionIds?: number[];
  finalActionId: number;
  useShareButton?: boolean;
  actionCount: number;
}

const STEP_SHARE_BASE: Record<number, StepShareMetaBase> = {
  1: {
    stepNumber: 1,
    shareName: 'Step One Summary',
    documentType: 'step-1',
    shareActionId: 4,
    finalActionId: 6,
    useShareButton: true,
    actionCount: 6,
  },
  2: {
    stepNumber: 2,
    shareName: 'Step Two Summary',
    documentType: 'step-2',
    shareActionId: 4,
    finalActionId: 5,
    actionCount: 5,
  },
  3: {
    stepNumber: 3,
    shareName: 'Step Three Summary',
    documentType: 'step-3',
    shareActionId: 5,
    finalActionId: 6,
    actionCount: 6,
  },
  4: {
    stepNumber: 4,
    shareName: 'Step Four Summary',
    documentType: 'step-4',
    shareActionId: 4,
    finalActionId: 5,
    actionCount: 5,
  },
  5: {
    stepNumber: 5,
    shareName: 'Step Five Summary',
    documentType: 'step-5',
    shareActionId: 5,
    finalActionId: 6,
    actionCount: 6,
  },
  6: {
    stepNumber: 6,
    shareName: 'Step Six Summary',
    documentType: 'step-6',
    shareActionId: 4,
    finalActionId: 5,
    actionCount: 5,
  },
  7: {
    stepNumber: 7,
    shareName: 'Step Seven Summary',
    documentType: 'step-7',
    shareActionId: 4,
    finalActionId: 5,
    actionCount: 5,
  },
  8: {
    stepNumber: 8,
    shareName: 'Step Eight Summary',
    documentType: 'step-8',
    shareActionId: 4,
    finalActionId: 5,
    actionCount: 5,
  },
  9: {
    stepNumber: 9,
    shareName: 'Step Nine Summary',
    documentType: 'step-9',
    shareActionId: 4,
    finalActionId: 5,
    actionCount: 5,
  },
  10: {
    stepNumber: 10,
    shareName: 'Step Ten Summary',
    documentType: 'step-10',
    shareActionId: 4,
    finalActionId: 5,
    actionCount: 5,
  },
  11: {
    stepNumber: 11,
    shareName: 'Step Eleven Summary',
    documentType: 'step-11',
    shareActionId: 4,
    finalActionId: 5,
    actionCount: 5,
  },
  12: {
    stepNumber: 12,
    shareName: 'Step Twelve Summary',
    documentType: 'step-12',
    shareActionId: 4,
    finalActionId: 5,
    actionCount: 5,
  },
};

export function getStepShareMeta(stepNumber: number): StepShareMeta {
  const base = STEP_SHARE_BASE[stepNumber];
  if (!base) {
    throw new Error(`No share config for step ${stepNumber}`);
  }
  return {
    stepNumber: base.stepNumber,
    stepTitle: getStepPageTitle(stepNumber),
    shareName: base.shareName,
    documentType: base.documentType,
    shareActionId: base.shareActionId,
    secondaryShareActionIds: base.secondaryShareActionIds,
    finalActionId: base.finalActionId,
    actionCount: base.actionCount,
    shareButtonText: base.useShareButton ? STEP_UI.SHARE_WITH_SPONSOR : undefined,
    actionLabels: getStepActionLabelsForStep(stepNumber),
  };
}

export function getShareButtonText(): string {
  return STEP_UI.SHARE_WITH_SPONSOR;
}

export { getDefaultShareEmptyMessage };

export {
  getShareActionTitle,
  getShareDefectsActionTitle,
} from './uiStrings';
